import { observer } from "mobx-react-lite";
import React from "react";
import "./styles.css";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

const PaginationComponent = (props: any) => {
  const { postsPerPage, totalPosts, paginate, currentPage } = props;
  const pageNumbers = [];

  for (let i = 1; i <= Math.ceil(totalPosts / postsPerPage); i++) {
    pageNumbers.push(i);
  }

  return (
    <nav>
      <ul className="pagination">
        <div
          className="pageLink"
          onClick={(e) =>
            currentPage > 1 ? paginate(currentPage - 1) : e.preventDefault()
          }
          aria-label="Previous"
        >
          <ChevronLeftIcon />
        </div>
        {pageNumbers
          .slice(
            currentPage <= 10
              ? 0
              : currentPage % 10 !== 0
              ? currentPage - (currentPage % 10)
              : currentPage - 10,
            currentPage <= 10
              ? 10
              : currentPage % 10 !== 0
              ? currentPage + (10 - (currentPage % 10))
              : currentPage
          )
          .map((number) => (
            <li
              key={number}
              onClick={() => paginate(number)}
              className={
                currentPage === number
                  ? "pageItem cursorPointer currentPage"
                  : "pageItem cursorPointer"
              }
            >
              <div className={"pageNumber"}>{number}</div>
            </li>
          ))}
        <div
          className="pageLink"
          onClick={(e) =>
            currentPage !== pageNumbers.length
              ? paginate(currentPage + 1)
              : e.preventDefault()
          }
          aria-label="Next"
        >
          <ChevronRightIcon/>
        </div>
      </ul>
    </nav>
  );
};

export default observer(PaginationComponent);
